'use strict';

angular.module('mobile-apps')
	.directive('tagActionButton',[
		'EntryMain',
		'TagMain',
		'LanguageEntries',
		'$stateParams',
		'$timeout',
		'$rootScope',
		'SweetAlert',
		function(
			EntryMain,
			TagMain,
			LanguageEntries,
			$stateParams,
			$timeout,
			$rootScope,
			SweetAlert
		) {
		return {
			scope:
			{
				postActionCallback: '&', // Optional
				entries: '=',
				tagCategories: '='
			},
			templateUrl: 'modules/mobile-apps/views/tag-action-button.client.directive.html',

			link: function (scope, element, attrs) {
				scope.status = {isOpen: false, changed: false};
				scope.filterString = '';
				scope.tagsSelected = {};
				scope.tagsSelectedStart = {};
				scope.tagsUndetermined = {};
				scope.tagsUndeterminedStart = {};
				scope.displayTags = [];
				scope.tagSelectorOpen = false;
				scope.prevFilterLength = 0;
				scope.newTagCategory = null;


				/**
				 * Returns array of currently selected entries
         		 */
				function getSelectedEntries() {
					var selectedEntries = [];
					scope.entries.forEach(function(entry) {
						if (entry.selected === true) {
							selectedEntries.push(entry);
						}
					});

					return selectedEntries;
				}


				/**
				 * Initializes the tag-list
				 */
				scope.init = function() {
					var selectedEntries = getSelectedEntries();

					// Init containsTagsCount and displayTags
					var containsTagsCount = {};
					var containsFuzzyTagsCount = {};

					scope.displayTags.length = 0;
					Object.keys(TagMain.tags).forEach(function(tagId) {
						containsTagsCount[tagId] = 0;
						scope.displayTags.push(TagMain.tags[tagId]);
                        containsFuzzyTagsCount[tagId] = false;
					});

					// Count which tags are on which entries to be able to
					// display checkboxes accordingly
					selectedEntries.forEach(function(entry) {
						if (entry._tags) {
							entry._tags.forEach(function(tagId) {
								containsTagsCount[tagId]++;

								var fuzzyKeys = TagMain.tags[tagId].fuzzyLanguageEntryIds || [];
                                var findFuzzyTagForEntry = fuzzyKeys.find(function (fuzzyKey) {
                                    return fuzzyKey === entry.key;
                                });
                                if(findFuzzyTagForEntry) {
                                    containsFuzzyTagsCount[tagId] = true;
                                }
							});
						}
					});

					// Set the checkbox values
					var numSelectedEntries = selectedEntries.length;
					Object.keys(TagMain.tags).forEach(function(tagId) {
						if (containsTagsCount[tagId] === 0) {
							scope.tagsSelected[tagId] = false;
							scope.tagsUndetermined[tagId] = false;
						} else {
							scope.tagsSelected[tagId] = containsTagsCount[tagId] === numSelectedEntries && !containsFuzzyTagsCount[tagId];
							scope.tagsUndetermined[tagId] = containsTagsCount[tagId] < numSelectedEntries || containsFuzzyTagsCount[tagId];
						}
						scope.tagsSelectedStart[tagId] = scope.tagsSelected[tagId];
						scope.tagsUndeterminedStart[tagId] = scope.tagsUndetermined[tagId];
					});
				};


				/**
				 * Opens the dropdown and then initializes the tag-list
		         */
				scope.displayDropdown = function($event) {
					$event.preventDefault();
					$event.stopPropagation();
					scope.status.isOpen = true;
					scope.init();
				};


				/**
				 * Special callback when checkbox gets clicked to know when
				 * an undetermined checkbox got clicked
		         */
				scope.toggledCheckbox = function(tagId) {

					if (scope.tagsUndetermined[tagId] === true) {
						scope.tagsUndetermined[tagId] = false;
						scope.tagsSelected[tagId] = false;
					}

					//scope.tagsUndetermined[tagId] = false;
					scope.status.changed = true;
				};


				/**
				 * Create a new tag with the given name and assign it to entries
				 * according to current selection
				 * @param tagName The name of the tag to create
				 */
				scope.createTag = function(tagName) {

					TagMain.createTag({name: tagName, category: scope.newTagCategory}, function(err, newTag) {
						if (err) {
							$timeout(function() {
								SweetAlert.swal(
									{
										title: 'Oops!',
										text: 'Sorry something went wrong',
										type: 'error',
										showCancelButton: false
									}
								);
							}, 50);
							return;
						}

						var tagChanges = {};
						tagChanges[newTag._id] = 'add';
						scope._applyTagChanges(tagChanges);
					})
				};


				/**
				 * Checks the current value of the checkboxes and adds/removes
				 * the tag to the entries accordingly
				 */
				scope.applyTags = function() {
					// Check what changed and create an object which specifies
					// which tags should get added and/or removed from the
					// currently selected entries.
					var tagChanges = {};
					Object.keys(scope.tagsSelectedStart).forEach(function(tagId) {
                        if (scope.tagsSelectedStart[tagId] !== scope.tagsSelected[tagId]) {
                            if (scope.tagsSelected[tagId] === true) {
                                // Add Tag to entries
                                tagChanges[tagId] = 'add';
                            } else {
                                // Remove Tag from entries
                                tagChanges[tagId] = 'remove';
                            }
                        } else if (scope.tagsUndeterminedStart[tagId] !== scope.tagsUndetermined[tagId]) {
                            // Remove Tag from entries
                            tagChanges[tagId] = 'remove';
                        }
					});


					scope._applyTagChanges(tagChanges);
				};


				/**
				 * Applies the given tag changes
				 */
				scope._applyTagChanges = function(tagChanges) {
					scope.status.isOpen = false;
					var selectedEntries = getSelectedEntries();
                    var entryKeys = [];

                    selectedEntries.forEach(function(entry) {
                        entryKeys.push(entry.key);

                        if(entry.linkedKeys && entry.linkedKeys.length) {

                            entry.linkedKeys.forEach(function (linkedKey) {
                               entryKeys.push(linkedKey);
                            });
                        }
                    });

					LanguageEntries.addRemoveTags({
						mobileAppId: $stateParams.mobileAppId,
						tags: tagChanges,
						entries: entryKeys
					}, function (response) {
						$rootScope.$broadcast('entriesChanged');

						if (angular.isFunction(scope.postActionCallback)) {
							scope.postActionCallback(entryKeys, entryKeys);
						}
					}, function (errorResponse) {

						$timeout(function() {
							SweetAlert.swal(
								{
									title: 'Oops!',
									text: 'Sorry something went wrong',
									type: 'error',
									showCancelButton: false
								}
							);
						}, 50);
					});
				};

				scope.getCategoryName = function(categoryName){
					if(scope.tagCategories && categoryName){
						var category = scope.tagCategories.find(function(item){ return item.name.toLowerCase() === categoryName.toLowerCase(); });
						if(category){
							return category.name;
						}
					}
					return 'None';
				};

				scope.getTagCategoryColor = function(categoryName){
					if(scope.tagCategories && categoryName){
						var category = scope.tagCategories.find(function(item){ return item.name.toLowerCase() === categoryName.toLowerCase(); });
						if(category){
							return category.color;
						}
					}
					return;
				};
		
				scope.getTagCategoryIcon = function(categoryName){
					if(scope.tagCategories && categoryName){
						var category = scope.tagCategories.find(function(item){ return item.name.toLowerCase() === categoryName.toLowerCase(); });
						if(category){
							return category.icon;
						}
					}
					return;
				};

				scope.openCategorySelector = function(){
					scope.tagSelectorOpen = !scope.tagSelectorOpen;
				};

				scope.updateSelectedCategory = function(categoryName){
					scope.newTagCategory = categoryName;
					scope.tagSelectorOpen = false;
					$('#taggingCategorySelector').removeClass('open');
					//scope.toogleCategoryMenu();
				};

				// Reset the list alway when the dropdown gets closed. If that
				// does not get done the checkbox undeterminded value does
				// not always get reset correctly
				scope.$watch('status.isOpen', function(isOpen) {
					if(scope.tagSelectorOpen || (scope.filteredList.length === 0 && scope.filterString !== '') && isOpen === false){
						scope.status.isOpen = true;
						if(scope.tagSelectorOpen){
							$('#taggingCategorySelector').addClass('open');
						}
					} else if (isOpen === false) {
						scope.status.isOpen = false;
						scope.tagSelectorOpen = false;
						scope.displayTags.length = 0;
						$('#taggingCategorySelector').removeClass('open');
					}
				});

				// Watching filter so that tag category dropdown adjust to its width
				scope.$watch('filterString', function(filterString) {
					$timeout(function(){
						if(filterString.length > 0){
							var filterWidth = parseInt($('.tag-filter').css('width'));
							var categoryMenuLeft = parseInt($('#ulTaggingCategorySelectMenu').css('left'));
							
							if(filterString.length < 9 && filterString.length > scope.prevFilterLength){
								categoryMenuLeft += 7;
							} else if(filterString.length < 8 && filterString.length < scope.prevFilterLength) {
								categoryMenuLeft -= 7;
							}
							
							$('#btnTaggingCategorySelect').css('width', filterWidth);
							if(filterString.length > 2){
								$('#ulTaggingCategorySelectMenu').css('left', categoryMenuLeft);
							} else {
								$('#ulTaggingCategorySelectMenu').css('left', '200px');
							}
							
						} else {
							$('#btnTaggingCategorySelect').css('width', '185px');
							$('#ulTaggingCategorySelectMenu').css('left', '200px');
						}
						scope.prevFilterLength = filterString.length;
					}, 33);
				});
			}
		};
	}]);
